<template>
  <div class="NotARefund">
    <div class="fl">
      <el-date-picker
      size="small"
      v-model="value2"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      :start-placeholder="businessStartDate"
      :end-placeholder="businessEndDate"
      @blur='timing'
      :clearable='false'
      :picker-options="pickerOptions">
    </el-date-picker>
      <el-input
        placeholder="请输入运单号"
        v-model="waybillNo"
        class="input-with-select"
        size="small"
        clearable
        style="width: 260px; margin-left: 12px;"
        @clear="searchWaybill"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchWaybill"></el-button>
      </el-input>
    </div>
    <div class="tables" >
      <el-table :data="tableData" style="width: 100%" height="100%" >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column prop="waybillNo" label="运单号" width=""  >
           <template slot-scope="scope">
            <span class="bgc-blue pointer" @click="TheWaybillDetails(scope.row)">{{scope.row.waybillNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="codAmount" label="代收金额(元)" width=""></el-table-column>
        <el-table-column prop="isSign" label="签收状态" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.isSign=='已签收'" class="green">{{scope.row.isSign}}</span>
            <span v-else>{{scope.row.isSign}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="businessDate" label="开单日期" sortable width="">
          <template slot-scope="scope">
            <span class="altitude">{{$moment(scope.row.businessDate).format("YYYY-MM-DD") || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payeeName " label="收款人" width="">
          <template slot-scope="scope">
            <span>{{scope.row.payeeName || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountNo" label="收款账号">
           <template slot-scope="scope">
           <el-popover placement="bottom" width="259" trigger="click" >
              <div class="popover-box"> 
                <div>
                  <span class="gray-word">收款人：</span>
                  <span>{{scope.row.payeeName || '-'}}</span>
                </div>
                <div class="top">
                  <span class="gray-word">收款账号：</span>
                  <span >{{scope.row.accountNo ||'-'}}</span>
                </div> 
                <div class="top">
                  <span class="gray-word">开户行：</span>
                  <span >{{scope.row.bankHqName ||'-'}}</span>                  
                </div>
                <div class="top">
                  <span class="gray-word">开户支行：</span>
                  <span >{{scope.row.bankBranchName ||'-'}}</span>   
                </div>       
                <div class="top">
                  <div style="font-size: 12px;">如对收货款账号有疑问，请联系发货网店或<span class="bgc-blue">95353</span>处理！</div>
                </div> 
              </div>
              <div class="bgc-blue pointer" slot="reference">{{scope.row.accountNo ||'-'}}</div>
           </el-popover>
          </template>
        </el-table-column>
        <el-table-column width="100"  align="right">
        <template slot="header" >
          <el-popover placement="bottom" width="259" trigger="click">
             <div class="popover-box" > 
                <div class="blod-font" style="font-size: 14px;">退款类型说明：</div>
                <div class="top">
                  <div><span class="blod-font">· 三日退：</span> 签收后第三天退款，节假日顺延；</div>
                </div>
                <div class="top">
                  <div><span class="blod-font">· 即日退：</span>签收后次日退款；</div>
                </div>   
                <div class="top">
                  <div><span class="blod-font">· 审核退：</span>需录入银行账号后才能退款，一般未签收后三日或发货网点审核时间为准。</div>
                </div>                             
              </div>
            <div class="Custom-table-headers fr pointer" slot="reference"> 
              <div>签收类型</div>
              <img class="img" src="../../../assets/picture/exclamation-point.png" alt="">
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <span class="fl">{{scope.row.codType}}</span>
        </template>
      </el-table-column>
      </el-table>
    </div>
    <div class="bottom" v-if="total>10">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currpage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagesize"
        layout="total,prev, pager, next, sizes,jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import API from "../../../api/collectionPayment";
import moment from 'moment'
const api = new API();
const DateOver = new Date(moment().add(-2, 'y').format("YYYY-MM-DD")).getTime()  // 获取 2年前 时间戳
export default {
   data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近14天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return  new Date <  time.getTime() || time.getTime() < DateOver
        }
      },
      DateOver:'',
      value2:'',
      businessEndDate:'',
      businessStartDate:'',
      currentPage: 1,
      pagesize:10,//每页的数据条数
      currpage:1,//默认开始页面
      total:0,
      value:'',
      options: [
        {value: "选项1",label: "最近7天",},
        {value: "选项2",label: "最近14天",},
        {value: "选项3",label: "最近1个月",},
        {value: "选项4",label: "自定义切换",},
      ],
      tableData: [],
      waybillNo: "",
    }
   },
  methods: {
    timing(){
      this.businessStartDate=this.$moment(this.value2[0]).format("YYYY-MM-DD")
      this.businessEndDate=this.$moment(this.value2[1]).format("YYYY-MM-DD")
      if(this.$moment(this.businessStartDate).diff(this.businessEndDate, 'y') < 0){
        return this.$message({
          message: '时间跨度不能超过1年!',
          type: "warning",
        });
      }
      this.queryCodAudits()
    },
    TheWaybillDetails(cell){//点击运单号 跳转运单详情
      console.log('点击运单号 跳转运单详情',cell);
    },
    // 分页 : 选择展示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.currpage = 1; // 切换 没有多少条的时候 重置为第1页开始
      this.queryCodAudits()
    },
    // 分页 : 换页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currpage = val
      this.queryCodAudits()
    },
    searchWaybill() {
      this.currpage = 1;
      this.queryCodAudits();
    },
    async queryCodAudits(){
      let parme = {
        "pageSize": this.pagesize,
        "currentPage": this.currpage,
        "isRefunded": 'N',
        "businessStartDate": this.businessStartDate+" 00:00:00",
        "businessEndDate": this.businessEndDate+" 23:59:59",
        "waybillNo": this.waybillNo != '' ? this.waybillNo : null,
      }
      let res = await api.queryCodAudits(parme)
      //银行卡脱敏
      this.tableData = res.list
      this.total = res.total
      this.tableData.forEach(item => {
        if(item.accountNo){
          let b = ''                      //  开头4位
          let c = ''                      // 结尾3位
          b=item.accountNo.slice(0,4);
          c=item.accountNo.slice(item.accountNo.length-3,item.accountNo.length); 
          var d =''
          for(let i = 0 ;i<(item.accountNo.length-7);i++){
            if(i%4 == 0 ){
              d =d + ' '
            }
            d = d+'*'
          }
          item.accountNo = b + d +  ' '+ c  
        }
      });   
    },
    TheefaDultTime(){
      this.businessStartDate = this.$moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD')
      this.businessEndDate = this.$moment().format('YYYY-MM-DD')
    },

  },
  created() {    
    this.TheefaDultTime()
    this.queryCodAudits()
    // console.log(this.businessStartDate,this.businessEndDate);
    // console.log(this.$moment(this.businessStartDate).diff(this.businessEndDate, 'y') < 0);
    // console.log( this.DateOver )
    // console.log(this.$moment().add(-2, 'y').format("YYYY-MM-DD HH:mm")) // 获取上两年
  },

}
</script>

<style lang='less' scoped>
.NotARefund {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 14px;
  .altitude {
    line-height: 31px;
  }
  .tables {
    // width: 100%;
    height: 82%;
    margin-top: 16px;
    padding: 16px;
    background-color: #fff;
    .green {
      color: rgba(41, 140, 42, 0.88);
    }
    .Custom-table-headers {
      display: flex;
      align-items:center;
      .img {
        width: 16px;
        height: 16px;
        margin-left: 8px;
      }
    }

  }
  .bottom {
    background-color: #fff;
    padding: 6px;
    padding-top: 0;
  }
}
</style>